import { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function VoiceRecorder({ onTranscript }) {
  const [recording, setRecording] = useState(false);
  const [busy, setBusy] = useState(false);
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream, { mimeType: "audio/webm" });
      chunksRef.current = [];
      mr.ondataavailable = (e) => e.data.size > 0 && chunksRef.current.push(e.data);
      mr.onstop = async () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        stream.getTracks().forEach((t) => t.stop());
        setBusy(true);
        try {
          const fd = new FormData();
          fd.append("file", blob, "voice.webm");
          const { data } = await api.post("/transcribe", fd, { headers: { "Content-Type": "multipart/form-data" } });
          onTranscript(data.text || "");
          toast.success("Transcribed");
        } catch (e) {
          toast.error("Transcription failed");
        } finally {
          setBusy(false);
        }
      };
      mr.start();
      mediaRef.current = mr;
      setRecording(true);
    } catch (e) {
      toast.error("Mic permission denied");
    }
  };

  const stop = () => {
    mediaRef.current?.stop();
    setRecording(false);
  };

  return (
    <button
      type="button"
      onClick={recording ? stop : start}
      disabled={busy}
      className={`h-12 w-12 flex items-center justify-center border ${
        recording ? "bg-rose-500 text-white border-rose-500 animate-pulse"
        : busy ? "border-zinc-700 text-zinc-500"
        : "border-zinc-700 text-zinc-100 hover:border-lime-400 hover:text-lime-400"
      } transition-colors`}
      data-testid="voice-record-btn"
      title={recording ? "Stop recording" : "Speak your design"}
    >
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : recording ? <Square className="w-4 h-4" /> : <Mic className="w-5 h-5" />}
    </button>
  );
}
